import { MenuDesignTokens } from '@primeuix/themes/aura/menu';

export const menuTokens: MenuDesignTokens = {
  root: {
    background: '{content.background}',
    borderColor: '{content.border.color}',
    borderRadius: '{content.border.radius}',
    color: '{color.main.primary}',
    shadow: '{overlay.navigation.shadow}',
    transitionDuration: '{transition.duration}',
  },
  list: {
    padding: '{navigation.list.padding}',
    gap: '{navigation.list.gap}',
  },
  item: {
    focusBackground: '{color.brand.subtle}',
    focusColor: '{color.main.primary}',
    color: '{color.main.primary}',
    padding: '{navigation.item.padding}',
    borderRadius: '{navigation.item.border.radius}',
    gap: '{navigation.item.gap}',
    icon: {
      color: '{color.main.tertiary}',
      focusColor: '{color.main.tertiary}',
    },
  },
  submenuLabel: {
    padding: '{navigation.submenu.label.padding}',
    fontWeight: '{navigation.submenu.label.font.weight}',
    background: '{navigation.submenu.label.background}',
    color: '{navigation.submenu.label.color}',
  },
  separator: {
    borderColor: '{content.border.color}',
  },
  css: ({ dt }) => `
    .p-menu-item-link:focus, .p-menu-item-link:active, .p-menu-item-link:hover {
      color: ${dt('menu.item.focus.color')};
    }

    .p-menu-separator {
      margin: 0.25rem 0;
    }

    .p-menu-item-label {
      line-height: 1.25rem;
    }

    li.delete-menu-item {
      .p-menu-item-content,
      .p-menu-item-link,
      .p-menu-item-icon {
        color: ${dt('color.fail.main')} !important;
      }
    }
  `,
};
